import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAPIError from '../../../../hooks/useAPIError';
import { TarjetaService } from '../../../../services';
import { useAuthStore } from '../../../../store/AuthContext';
import IconBack from '../../../../Icons/IconBack';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  setReload?: (visible: boolean) => void;
}

const BajaOroForm: FC<Props> = (props) => {
  const { visible, setVisible, setReload } = props;
  const dataUser = useAuthStore();
  const { t } = useTranslation();
  const { addError, addWarning, addOro } = useAPIError();

  const [load, setLoad] = useState<boolean>(false);

  useEffect(() => {
    if (dataUser.user.token !== '') setLoad(true);
  }, [dataUser.user.token]);

  const hideModal = (reload: boolean) => {
    addOro(false);
    setVisible(false);
    document.body.classList.remove('fix');
    if (reload && setReload !== undefined) {
      setReload(true);
    }
  };

  const doBaja = () => {
    addOro(true);
    TarjetaService.solicitarBajaOro()
      .then((response) => {
        if (response.data.error === true) {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        } else {
          const { pojo } = response.data;
          if (pojo) {
            const { message } = pojo;
            const { isChanged } = pojo;
            addWarning(message);
            hideModal(isChanged);
          }
        }
      })
      .catch((er: any) => {
        console.log(er);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('baja-oro-btn').click();
    }
  };

  useEffect(() => {
    if (visible) {
      const element = document.querySelector(
        'section.o-section--large.form-baja.bloque-form.visible',
      ) as HTMLElement;
      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    } else if (load) {
      const element = document.querySelector(
        'section.o-section--large.form-baja.bloque-form',
      ) as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
    }
  }, [visible, load]);

  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              <section
                className={`o-section--large form-baja bloque-form ${
                  visible ? 'visible' : ''
                }`}
              >
                <div className="container">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <a
                    className="link-prev"
                    onClick={() => {
                      hideModal(false);
                    }}
                  >
                    <div className="icon icon-medium">
                      <IconBack />
                    </div>
                    <p className="u-font-normal u-text-brand u-margin-left">
                      {t('datos.baja.back')}
                    </p>
                  </a>
                  <h2 className="bloque-datos__title u-text-oro">
                    <span className="divider__square brand-gold-color" />
                    <span className="u-margin-right">
                      {t('tarjetas.tarjeta-oro-datos.confirmacion-baja')}
                    </span>
                  </h2>

                  <div className="row">
                    <div className="col-12 col-md-8">
                      <p className="u-margin-bottom-large">
                        {t('tarjetas.tarjeta-oro-datos.quieres-darte-baja')}
                      </p>
                      <ul className="lista-requisitos">
                        <li>{t('tarjetas.tarjeta-oro-datos.title')}</li>
                      </ul>
                    </div>
                  </div>

                  <div className="u-text-right u-margin-top">
                    <button
                      type="button"
                      className="btn btn-secundary btn-secundary__oro u-margin-right-large"
                      onClick={() => {
                        setVisible(false);
                        document.body.classList.remove('fix');
                      }}
                    >
                      {t('datos.baja.i-think-better')}
                    </button>
                    <button
                      id="baja-oro-btn"
                      type="button"
                      className="btn btn-oro"
                      onClick={() => {
                        doBaja();
                      }}
                    >
                      Confirmar baja
                    </button>
                  </div>
                </div>
              </section>{' '}
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default BajaOroForm;
